import React, { useState, useEffect, useRef, useContext, Suspense } from 'react';
import { Link, useParams, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import ContentLoader, { Facebook, Instagram, Code, BulletList } from 'react-content-loader'
import { AppContext } from '../context/AppContext.jsx';
import { useLanguage, LanguageProvider } from "../i18n/LanguageContext.jsx";
import axios from 'axios';
import i18n from '../i18n/i18n.js';

Array.prototype.last = function () {
    return this[this.length - 1];
};

const PageRouter = () => {
    const params = useParams();
    const [item, setItem] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const itemName = params["*"].length ? params["*"].split(/\//)?.last() : null;
    const itemPath = params["*"].split("/").slice(0, -1).join("/")
    const { language } = useLanguage();
    const { siteMap, error } = useContext(AppContext);

    let parameters = new URLSearchParams();
    for (const [key, value] of searchParams.entries()) {
        parameters.append(key, value);
    }

    //const qsParams = {};

    //for (const [key, value] of searchParams.entries()) {
    //	qsParams[key] = value
    //}

    //console.log(qsParams)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`/${language}/contents/item/${itemName}?path=${itemPath}`);
                const response = res.data;
                setItem(response);
            } catch (error) {
                ////console.error('Errore durante il fetchl\'item:', error);

            } finally {

            }
        };

        fetchData();
    }, [params["*"]]);

    useEffect(() => {
        if (!error) return;
        let errorKey, errorCode;
        switch (error.status) {
            case 404:
                errorKey = "NotFound"
                errorCode = "404"
                break;
            default:
                errorKey = "GenericError"
                errorCode = "500"
        }

        setItem({
            type: "Errors",
            model: {
                title: i18n[language][errorKey],
                errorCode: errorCode,
                templateName: "Error"
            }
        })
    }, [error])

    return (
        <>
            {!item && (
                <>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col px-0 position-relative page-hero-container bg-black' style={{ height: "300px" }}>
                            </div>
                        </div>
                    </div>
                    <div className="container-xl bg-white pt-5" style={{ minHeight: 800 }}>
                        <div className="row justify-content-center px-3">
                            <div className="col-sm-4 grid-item mb-4">
                                <Instagram backgroundColor="#ededed" foregroundColor="#fafafa" height={400} width={`100%`} viewBox="0 0 100 100%" style={{ width: '100%' }} />
                            </div>
                            <div className="col-sm-4 grid-item mb-4">
                                <Instagram backgroundColor="#ededed" foregroundColor="#fafafa" height={400} width={`100%`} viewBox="0 0 100 100%" style={{ width: '100%' }} />
                            </div>
                            <div className="col-sm-4 grid-item mb-4">
                                <Instagram backgroundColor="#ededed" foregroundColor="#fafafa" height={400} width={`100%`} viewBox="0 0 100 100%" style={{ width: '100%' }} />
                            </div>

                        </div>
                    </div>
                </>
            )}

            {item && (
                <>
                    <Suspense fallback={
                        <div className="loading-component">
                            <div className='container-fluid'>
                                <div className='row'>
                                    <div className='col px-0 position-relative page-hero-container bg-dark' style={{ height: "300px" }}>
                                    </div>
                                </div>
                            </div>
                            <div className="container-xl bg-white pt-5" style={{ minHeight: 800 }}>
                                <div className="row justify-content-center px-3">
                                    <div className="col-sm-4 grid-item mb-4">
                                        <Instagram backgroundColor="#ededed" foregroundColor="#fafafa" height={400} width={`100%`} viewBox="0 0 100 100%" style={{ width: '100%' }} />
                                    </div>
                                    <div className="col-sm-4 grid-item mb-4">
                                        <Instagram backgroundColor="#ededed" foregroundColor="#fafafa" height={400} width={`100%`} viewBox="0 0 100 100%" style={{ width: '100%' }} />
                                    </div>
                                    <div className="col-sm-4 grid-item mb-4">
                                        <Instagram backgroundColor="#ededed" foregroundColor="#fafafa" height={400} width={`100%`} viewBox="0 0 100 100%" style={{ width: '100%' }} />
                                    </div>

                                </div>
                            </div>
                        </div>
                    }>
                        {[item].map((el, i) => {
                            var TemplateComponent = null;
                            //if (el.model.templateName == "Lab" || el.model.customFields) {
                            //	console.log(el.model.templateName)
                            //	TemplateComponent = React.lazy(() =>
                            //		import(`/Content/js/react/templates/Article/LabTemplate.jsx`)
                            //	);
                            //} else {
                            //	TemplateComponent = React.lazy(() =>
                            //		import(`/Content/js/react/templates/${el.type}/${el.model.templateName || "Standard"}Template.jsx`)
                            //	);
                            //}
                            TemplateComponent = React.lazy(() =>
                                import(`/Content/js/react/templates/${el.type}/${el.model.templateName || "Standard"}Template.jsx`)
                            );
                            return <TemplateComponent key={i} item={el.model} qsparams={parameters} lang={language} />;
                        })}
                    </Suspense>
                </>
            )}
        </>
    )
}

export default PageRouter;
